import * as React from "react";
const SvgFiRrTilde = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tilde_svg__a)">
      <path
        fill="#062147"
        d="M18.474 20c-2.77 0-5.125-1.918-6.462-5.263L10.18 9.936c-.47-1.173-1.873-3.937-4.626-3.937-1.993 0-3.553 1.631-3.553 3.714v5.286a1 1 0 0 1-2 0V9.713c0-3.204 2.439-5.714 5.553-5.714 2.799 0 5.165 1.898 6.489 5.208l1.832 4.801c.593 1.481 1.986 3.99 4.6 3.99 2.011 0 3.526-1.597 3.526-3.714V8.998a1 1 0 1 1 2 0v5.286c0 3.204-2.428 5.714-5.526 5.714z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tilde_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTilde;
